document.addEventListener("DOMContentLoaded", () => {
	const sliders = Array.from(
		document.querySelectorAll(".wp-block-wpb-query-loop.swiper"),
	);

	if (!sliders.length) return;

	sliders.forEach((swiper, index) => {
		const speedModifier = index * 300;
		const itemsMobile = +swiper.dataset.itemsRowMobile || 1;
		const itemsTablet = +swiper.dataset.itemsRowTablet || 2;
		const itemsDesktop = +swiper.dataset.itemsRowDesktop || 3;
		const speed = +swiper.dataset.speed || 300;
		const delay = +swiper.dataset.delay;
		const enableAnimationLoop = swiper.dataset.enableAnimationLoop === "true";
		const spaceBetween = +swiper.dataset.spaceBetween;
		const enableNavigation = swiper.dataset.enableNavigation === "true";
		const enablePagination = swiper.dataset.enablePagination === "true";

		const swiperConfig = {
			slidesPerView: itemsMobile,
			speed,
			spaceBetween,
			slideClass: "wp-block-wpb-post-template",
			loop: enableAnimationLoop,
			autoplay: {
				delay: delay + speedModifier,
				pauseOnMouseEnter: true,
			},
			breakpoints: {
				840: { slidesPerView: itemsTablet },
				1200: { slidesPerView: itemsDesktop },
			},
		};

		const wrapper =
			swiper.closest(".wp-block-wpb-query-loop-wrapper") ?? swiper;

		if (enablePagination) {
			swiperConfig.pagination = {
				el: wrapper.querySelector(".wp-block-wpb-query-loop-swiper-pagination"),
				clickable: true,
			};
		}

		if (enableNavigation) {
			swiperConfig.navigation = {
				nextEl: wrapper.querySelector(".wp-block-wpb-query-loop-button-next"),
				prevEl: wrapper.querySelector(".wp-block-wpb-query-loop-button-prev"),
			};
		}

		new Swiper(swiper, swiperConfig);
	});
});
